import React from 'react';
import { NavLink } from 'react-router-dom';
import { canAccess } from '../../config/roleAccess';
import { REFRESH_NAV_GROUPS } from '../../config/uiRefreshNav';

interface RefreshSidebarNavProps {
  role: string | null | undefined;
  onNavigate?: () => void;
}

/**
 * Persona-grouped nav shown instead of the legacy sidebar list when the UI refresh
 * flag is on. Same routes, same role gates; groups with no visible item are dropped.
 */
const RefreshSidebarNav: React.FC<RefreshSidebarNavProps> = ({ role, onNavigate }) => (
  <nav className="flex flex-col gap-1" aria-label="Main" data-testid="refresh-nav">
    {REFRESH_NAV_GROUPS.map((group) => {
      const items = group.items.filter((item) => (item.enabled?.() ?? true) && canAccess(role, item.feature));
      if (items.length === 0) return null;
      return (
        <div key={group.id} className="mt-4 px-1" role="group" aria-label={group.title}>
          <div className="mb-1 px-2 py-1 text-xs font-semibold uppercase text-muted-foreground">
            {group.title}
          </div>
          <div className="flex flex-col gap-1">
            {items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={onNavigate}
                className={({ isActive }) => `
                  flex items-center justify-between gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors
                  ${isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'}
                `}
              >
                <span className="truncate">{item.label}</span>
                {item.sample && (
                  <span className="rounded bg-muted px-1.5 py-0.5 text-[10px] font-semibold uppercase text-muted-foreground">
                    Sample
                  </span>
                )}
              </NavLink>
            ))}
          </div>
        </div>
      );
    })}
  </nav>
);

export default RefreshSidebarNav;
